export default (function () {
  return function (next) {
    return function (action) {
      return (// functionality moved to middleware/metrics/sagas/google-tag-manager
        // leaving this here to not break export
        next(action)
      );
    };
  };
});